<template>
  <div class="project-wrapper">
    <div class="project-container">
      <div class="project-content">
        <p class="project-current-step">{{ Translator('soprasolar.project.step3_shade.step') }}</p>
        <h1 class="project-title">{{ Translator('soprasolar.project.step3_shade.title') }}</h1>
        <save />
      </div>
      <div class="project-content">
        <form @submit="onSubmit" ref="form" id="form" class="std-form">
          <div class="form-group">
            <div class="form-label-container">
              <label for="modules_choices" class="control-label required">
                {{ Translator('soprasolar.project.step3_shade.form.modules_choices.label') }}
                <span>({{ Translator('soprasolar.project.step3_shade.form.modules_choices.label_more') }})</span>
              </label>
            </div>
            <select id="modules_choices" required class="form-control" v-model="form.modules_choices">
              <option value=""></option>
              <option value="dualsun_410">{{ Translator('soprasolar.project.step3_shade.form.modules_choices.dualsun_410') }}</option>
              <option value="voltec_110_VSMP_435_460">{{ Translator('soprasolar.project.step3_shade.form.modules_choices.voltec_110_VSMP_435_460') }}</option>
              <option value="voltec_110_VSBP_435_460">{{ Translator('soprasolar.project.step3_shade.form.modules_choices.voltec_110_VSBP_435_460') }}</option>
              <option value="jinko_450_475_DB">{{ Translator('soprasolar.project.step3_shade.form.modules_choices.jinko_450_475_DB') }}</option>
              <option value="jinko_450_475_DV">{{ Translator('soprasolar.project.step3_shade.form.modules_choices.jinko_450_475_DV') }}</option>
              <option value="jinko_445_470_BDV">{{ Translator('soprasolar.project.step3_shade.form.modules_choices.jinko_445_470_BDV') }}</option>
              <option value="ja_solar_435_465">{{ Translator('soprasolar.project.step3_shade.form.modules_choices.ja_solar_435_465') }}</option>
              <option value="dmegc_B54HBT_440_460">{{ Translator('soprasolar.project.step3_shade.form.modules_choices.dmegc_B54HBT_440_460') }}</option>
              <option value="dmegc_455_475">{{ Translator('soprasolar.project.step3_shade.form.modules_choices.dmegc_455_475') }}</option>
              <option value="dmegc_500">{{ Translator('soprasolar.project.step3_shade.form.modules_choices.dmegc_500') }}</option>
              <option value="other">{{ Translator('soprasolar.project.step3_shade.form.modules_choices.other') }}</option>
              <option value="dontknow">{{ Translator('soprasolar.project.step3_shade.form.modules_choices.dontknow') }}</option>
            </select>
          </div>
          <div class="form-group" v-if="form.modules_choices === 'other'">
            <input type="text" required id="modules_choices_other" :placeholder="Translator('soprasolar.project.step3_shade.form.modules_other')" class="form-control" v-model="form.modules_choices_other">
          </div>
          <div class="form-group">
            <div class="form-label-container">
              <label for="coefficient" class="control-label required">
                {{ Translator('soprasolar.project.step3_shade.form.sizes.label') }}
              </label>
            </div>

            <div class="radios">
              <div class="radio">
                <input class="radio-input" required type="radio" id="sizes_approximate" name="sizes" v-model="form.sizes" value="approximate">
                <label class="radio-label" for="sizes_approximate">
                  <p class="radio-label-text">{{ Translator('soprasolar.project.step3_shade.form.sizes.approximate') }}</p>
                  <div class="radio-label-media">
                    <img src="/assets/soprasolar/images/project/sizes_approximate.png" :alt="Translator('soprasolar.project.step3_shade.form.sizes.approximate')">
                  </div>
                </label>
              </div>
              <div class="radio">
                <input class="radio-input" required type="radio" id="sizes_modules" name="sizes" v-model="form.sizes" value="modules">
                <label class="radio-label" for="sizes_modules">
                  <p class="radio-label-text">{{ Translator('soprasolar.project.step3_shade.form.sizes.modules') }}</p>
                  <div class="radio-label-media">
                    <img src="/assets/soprasolar/images/project/sizes_modules.png" :alt="Translator('soprasolar.project.step3_shade.form.sizes.modules')">
                  </div>
                </label>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="project-footer">
      <div class="project-actions">
        <button type="submit" class="button-flat" form="form" :disabled="isLoading">
          {{ Translator('soprasolar.project.next') }}
          <i class="ic ic-arrow-right" v-if="!isLoading"></i>
          <span class="button-loader" v-if="isLoading"></span>
        </button>
        <button type="button" class="button-link" @click="onPrevious">
          <i class="ic ic-arrow-left"></i>
          {{ Translator('soprasolar.project.previous') }}
        </button>
      </div>
    </div>
    <p class="project-legend">* {{ Translator('soprasolar.project.required_field') }}</p>
  </div>
</template>
<style scoped lang="scss">
@import "~@/soprasolar-project/assets/styles/import";
.project-wrapper {
  @include vertical-spacing-inner-top;
}
</style>
<script>
import FormControl from 'aw-front-helpers/classes/formControl';
import AppControlService from '@/soprasolar-project/services/AppControl';
import Save from '@/soprasolar-project/components/Save';

export default {
  name: 'step-3-shade',
  components: {
    Save
  },
  data () {
    return {
      datas: AppControlService.datas,
      isLoading: false,
      form: {}
    }
  },

  created() {
    AppControlService.on('datas', this._onUpdateDatas);
  },

  beforeDestroy() {
    AppControlService.off('datas', this._onUpdateDatas);
  },

  mounted() {
    this._form = new FormControl(this.$refs.form);
    if(this.datas.step3) this.form = this.datas.step3;
  },
  methods: {
    onChangeModule() {
      delete this.form.module_other;
    },

    onSubmit(pEvt) {
      pEvt.preventDefault();
      if(this._form.isValidate) {
        if(this.isLoading) return;
        this.isLoading = true;
        if(this.datas.step3 && this.form.sizes !== this.datas.step3.type) {
          AppControlService.delete('step4');
        }
        AppControlService.update('step3', this.form).then( () => {
          AppControlService.goToNextStep();
        }).catch(console.error).then(() => {
          this.isLoading = false;
        })
      }
    },

    onPrevious() {
      AppControlService.goToPrevStep();
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },

    _onUpdateDatas(datas) {
      this.datas = datas;
      if(this.datas.step3) this.form = this.datas.step3;
    }
  }
};
</script>